import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios';

export default function CommercialDocumentModal({ document, onHide }) {
    const [html, setHtml] = useState('');
    const [error, setError] = useState('');
    const [ready, setReady] = useState(false);
    const frame = useRef(null);
    const url = document?.url;
    useEffect(() => {
        if (!url) return;
        const controller = new AbortController();
        setHtml(''); setError(''); setReady(false);
        axios.get(url, { responseType: 'text', signal: controller.signal })
            .then(({ data }) => { if (!controller.signal.aborted) setHtml(data); })
            .catch(() => { if (!controller.signal.aborted) setError('Não foi possível emitir o documento. Confira seu acesso e tente novamente.'); });
        return () => controller.abort();
    }, [url]);
    return <Modal show={Boolean(document)} onHide={onHide} size="xl" centered>
        <Modal.Header closeButton><Modal.Title>{document?.title}</Modal.Title></Modal.Header>
        <Modal.Body>{error ? <Alert variant="danger">{error}</Alert> : !html ? <Spinner animation="border" role="status" /> :
            <iframe ref={frame} title="Documento comercial" srcDoc={html} sandbox="allow-same-origin allow-modals" onLoad={() => setReady(true)} style={{ width: '100%', height: '65vh', border: '1px solid #dce3e8', borderRadius: 8 }} />}
        </Modal.Body><Modal.Footer><span className="text-muted me-auto">Na impressão, escolha Salvar como PDF para baixar.</span><Button variant="light" onClick={onHide}>Fechar</Button><Button disabled={!html || !ready || Boolean(error)} onClick={() => { frame.current.contentWindow.focus(); frame.current.contentWindow.print(); }}>Imprimir / salvar PDF</Button></Modal.Footer>
    </Modal>;
}
